module.exports = __webpack_public_path__ + "5e45418158433a79dec6589617f5fe02.png";